import {Button, Flex} from 'antd';
import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import ResetPassword from './ResetPassword';
import ResetWebenable from './ResetWebenable';

const ResetPasswordAndWebenable = () => {
  const {selectedMember} = useSelector((state: any) => state?.selectedMember);
  const currentMemberData = selectedMember.currentMemberDetails;

  const [isResetPasswordvisible, setResetPasswordVisible] = useState(false);
  const [isResetWebenablevisible, setResetWebenableVisible] = useState(false);
  const hideResetPasswordModal = (e) => {
    setResetPasswordVisible(!isResetPasswordvisible);
  };
  const hideResetWebenableModal = (e) => {
    setResetWebenableVisible(!isResetWebenablevisible);
  };
  const handleResetPasswordClick = () => {
    setResetPasswordVisible(!isResetPasswordvisible);
  };
  const handleResetWebenableClick = () => {
    setResetWebenableVisible(!isResetWebenablevisible);
  };
  return (
    // `wrap` + `gap` instead of `justify="space-between"`: at the sidebar's
    // fixed 272px width, "Reset Password" + "Reset Credentials" side-by-side
    // don't both fit — space-between doesn't shrink or wrap them, so the
    // second button's label was getting clipped by the sidebar's edge. This
    // wraps to two lines when needed instead of overflowing.
    <Flex wrap gap={8} style={{paddingBottom: 10}}>
      <Button
        size="small"
        type="primary"
        disabled={
          currentMemberData?.status?.toUpperCase() !== 'ACTIVE' || !currentMemberData?.isWebEnabled
        }
        onClick={handleResetPasswordClick}>
        Reset Password
      </Button>
      {currentMemberData?.status?.toUpperCase() === 'ACTIVE' && currentMemberData?.isWebEnabled ? (
        <ResetPassword
          openResetPasswordDialog={isResetPasswordvisible}
          isOpenResetPasswordDialog={hideResetPasswordModal}
        />
      ) : (
        ''
      )}

      <Button
        size="small"
        type="primary"
        disabled={
          currentMemberData?.status?.toUpperCase() !== 'ACTIVE' || !currentMemberData?.isWebEnabled
        }
        onClick={handleResetWebenableClick}>
        Reset Credentials
      </Button>

      {currentMemberData?.status?.toUpperCase() === 'ACTIVE' && currentMemberData?.isWebEnabled ? (
        <ResetWebenable
          openResetWebenableDialog={isResetWebenablevisible}
          isResetWebenableDialog={hideResetWebenableModal}
          data-test="reset-webenable"
        />
      ) : (
        ''
      )}
    </Flex>
  );
};

export default ResetPasswordAndWebenable;
